import { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { Badge } from "@/components/StatusBadge";
import { Input } from "@/components/ui/input";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { History as HistoryIcon } from "lucide-react";

const ACTION_LABELS = {
  create: "Oluştur",
  update: "Güncelle",
  delete: "Sil",
  cancel: "İptal",
  approve: "Onay",
  reject: "Red",
};

const ACTION_VARIANT = {
  create: "success",
  update: "info",
  delete: "error",
  cancel: "warning",
};

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  const [entityType, setEntityType] = useState("all");
  const [q, setQ] = useState("");

  const load = async () => {
    const params = {};
    if (entityType !== "all") params.entity_type = entityType;
    const { data } = await api.get("/audit-logs", { params });
    setLogs(data);
  };
  useEffect(() => { load(); }, [entityType]);

  const filtered = q
    ? logs.filter((l) => (l.user_name || "").toLowerCase().includes(q.toLowerCase()) ||
                          (l.entity_type || "").toLowerCase().includes(q.toLowerCase()) ||
                          (l.action || "").toLowerCase().includes(q.toLowerCase()))
    : logs;

  return (
    <div className="space-y-4">
      <div className="azd-card p-5 flex items-start gap-4">
        <div className="w-12 h-12 rounded-lg bg-[#0B3676]/10 text-[#0B3676] flex items-center justify-center">
          <HistoryIcon size={22} />
        </div>
        <div className="flex-1">
          <div className="text-xs uppercase tracking-wider font-bold text-[#6B7280]">Toplam</div>
          <div className="text-2xl font-extrabold text-[#08285A]">{logs.length} kayıt</div>
          <div className="text-xs text-[#6B7280] mt-1">
            Son 200 sistem aktivitesi gösteriliyor
          </div>
        </div>
      </div>

      <div className="azd-card p-4 lg:p-5">
        <div className="grid lg:grid-cols-3 gap-3">
          <div>
            <label className="block text-xs font-semibold text-[#111827] mb-1.5">Ara</label>
            <Input value={q} onChange={(e) => setQ(e.target.value)}
                   placeholder="Kullanıcı, varlık, aksiyon..." data-testid="audit-search" />
          </div>
          <div>
            <label className="block text-xs font-semibold text-[#111827] mb-1.5">Varlık Tipi</label>
            <Select value={entityType} onValueChange={setEntityType}>
              <SelectTrigger><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Tümü</SelectItem>
                <SelectItem value="product">Ürün</SelectItem>
                <SelectItem value="company">Firma</SelectItem>
                <SelectItem value="quote">Teklif</SelectItem>
                <SelectItem value="order">Sipariş</SelectItem>
                <SelectItem value="payment">Ödeme</SelectItem>
                <SelectItem value="user">Kullanıcı</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>

      <div className="azd-card overflow-hidden">
        <div className="overflow-x-auto azd-scrollbar">
          <table className="w-full text-sm">
            <thead className="bg-[#F6F8FB] text-[11px] uppercase tracking-wider text-[#6B7280]">
              <tr>
                <th className="text-left px-4 py-3 font-semibold">Tarih</th>
                <th className="text-left px-4 py-3 font-semibold">Kullanıcı</th>
                <th className="text-left px-4 py-3 font-semibold">Aksiyon</th>
                <th className="text-left px-4 py-3 font-semibold">Varlık</th>
                <th className="text-left px-4 py-3 font-semibold">Kayıt ID</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr><td colSpan={5} className="p-8 text-center text-[#6B7280]">
                  Audit kaydı bulunamadı
                </td></tr>
              ) : filtered.map((l) => (
                <tr key={l.id} className="border-t border-[#E5E7EB] hover:bg-[#F6F8FB]/50">
                  <td className="px-4 py-3 text-xs text-[#6B7280]">{fmtDateTime(l.created_at)}</td>
                  <td className="px-4 py-3 font-semibold text-[#111827]">{l.user_name}</td>
                  <td className="px-4 py-3">
                    <Badge variant={ACTION_VARIANT[l.action] || "default"}>
                      {ACTION_LABELS[l.action] || l.action}
                    </Badge>
                  </td>
                  <td className="px-4 py-3 text-[#6B7280]">{l.entity_type}</td>
                  <td className="px-4 py-3 text-xs font-mono text-[#6B7280]">{(l.entity_id || "").slice(0, 12)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
